export default "__VITE_ASSET__b194e819__"